export default {
  "content": "<path d=\"M12.5 21a9.004 9.004 0 008.716-6.747M12.5 21a9.004 9.004 0 01-8.716-6.747M12.5 21c2.485 0 4.5-4.03 4.5-9s-2.015-9-4.5-9m0 18C10.015 21 8 16.97 8 12s2.015-9 4.5-9m0 0a8.997 8.997 0 017.843 4.582M12.5 3a8.997 8.997 0 00-7.843 4.582m15.686 0A11.953 11.953 0 0112.5 10.5c-2.998 0-5.74-1.1-7.843-2.918m15.686 0A8.959 8.959 0 0121.5 12c0 .778-.099 1.533-.284 2.253m0 0A17.919 17.919 0 0112.5 16.5c-3.162 0-6.133-.815-8.716-2.247m0 0A9.015 9.015 0 013.5 12c0-1.605.42-3.113 1.157-4.418\" stroke=\"currentColor\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>",
  "attrs": {
    "xmlns": "http://www.w3.org/2000/svg",
    "width": "25",
    "height": "24",
    "viewBox": "0 0 25 24",
    "fill": "none"
  }
};